import React from 'react';
import Typography from '@latitude/typography';
import ProofPointRebrand from '../ProofPointRebrand/ProofPointRebrand';
import {
  Wrapper,
  StyledPopCollectionContainer,
  StyledPopContentContainer
} from './ProofPointCollectionRebrand.styled';

const COMPONENT_ID = 'proof-point-collection-rebrand';

const ProofPointCollection = props => {
   const { title, proofPoints, trackingId, ...rest } = props.data;

  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;


  return (
    <Wrapper className={componentIdentifier} {...rest}>
    <StyledPopCollectionContainer>
      <Typography.H4>
        {title}
      </Typography.H4>
      <StyledPopContentContainer
        className={`${componentIdentifier}-content-container`}
      >
        {proofPoints?.map((point, index) => (
          <ProofPointRebrand
            key={index}
            point={point}
            numOfPoints={proofPoints?.length}
            title={title}
          />
        ))}
      </StyledPopContentContainer>
    </StyledPopCollectionContainer>
    </Wrapper>
  );
};

export default ProofPointCollection;
